module.exports = __webpack_public_path__ + "img/p2-9.1ce74568.png";